<template>
  <div v-if="page">
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>{{page.name}}</v-toolbar-title>
    </v-toolbar>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-text v-html="page.content"></v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    slug: null
  }),
  computed: {
    ...mapGetters("static", ["page"])
  },
  mounted() {
    this.slug = this.$route.params.pathMatch;
    this.initialize();
  },
  methods: {
    ...mapActions("static", { getPage: "get" }),
    initialize() {
      if (this.slug) {
        this.getPage(this.slug);
      }
    }
  }
};
</script>

<style>
</style>